export class ChartRepository {
  static dateToAge(dateString) {
    console.log('dateString', dateString)
    // YYYY-MM-DD
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  } 
}